import { sanitize } from 'isomorphic-dompurify';
import { PanelContent } from 'shared/sections/TechnicalExpertise/ExpertisePanel';
import BadgeList from 'shared/sections/TechnicalExpertise/ExpertisePanel/ExpertisePanelContent/BadgeList';

import cn from './style.module.sass';

type ExpertisePanelContentProps = {
    currentList: PanelContent[];
};
export default function ExpertisePanelContent({ currentList }: ExpertisePanelContentProps) {
    return (
        <div className={cn['expertisePanelContent']}>
            {currentList.map(el => (
                <div key={el.title} className={cn['expertisePanelContent__card']}>
                    {el.title && (
                        <div className={cn['expertisePanelContent__title']}>{el.title}</div>
                    )}
                    <BadgeList products={el.products} />
                    {el.content && (
                        <div
                            dangerouslySetInnerHTML={{ __html: sanitize(el.content) }}
                            className={cn['expertisePanelContent__content']}
                        />
                    )}
                </div>
            ))}
        </div>
    );
}
